import React from "react";
import styles from "./ComponentRenderError.module.scss";

const ComponentRenderError = ({children}) => {
    return <div className={styles.base}>
        {children}
    </div>
};

export default ComponentRenderError;